import React, { useState, useEffect } from 'react';

interface LoadingBarProps {
  isLoading: boolean;
}

const LoadingBar: React.FC<LoadingBarProps> = ({ isLoading }) => {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let progressInterval: NodeJS.Timeout;
    let fadeTimeout: NodeJS.Timeout;

    if (isLoading) {
      setVisible(true);
      setProgress(0);
      
      // Simulate progress
      progressInterval = setInterval(() => {
        setProgress(prev => {
          // Progress gets slower as it approaches 90%
          if (prev < 30) return prev + 5;
          if (prev < 60) return prev + 3;
          if (prev < 80) return prev + 1;
          if (prev < 90) return prev + 0.5;
          return prev;
        });
      }, 100);
    } else if (visible) {
      // Complete the progress bar
      setProgress(100);
      
      // Fade out after completion
      fadeTimeout = setTimeout(() => {
        setVisible(false);
      }, 300);
    }

    return () => {
      clearInterval(progressInterval);
      clearTimeout(fadeTimeout);
    };
  }, [isLoading]);

  if (!visible) return null;

  return (
    <div 
      className="fixed top-0 left-0 right-0 z-50 h-[2px] bg-black dark:bg-white"
      style={{ 
        width: `${progress}%`,
        transition: isLoading ? 'width 0.2s ease-in-out' : 'width 0.1s ease-out, opacity 0.3s ease-out',
        opacity: isLoading || progress < 100 ? 1 : 0
      }}
    />
  );
};

export default LoadingBar;